import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './authInterceptor'; // N-100: глобальный перехватчик истёкшего токена (401/403 -> /login)
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Referrals from './pages/Referrals';
import Transactions from './pages/Transactions';
import Commissions from './pages/Commissions';
import Operations from './pages/Operations';
import Stoplist from './pages/Stoplist';
import Support from './pages/Support';
import Profile from './pages/Profile';
import Api from './pages/Api';
import Notifications from './pages/Notifications';
import Services from './pages/Services';
import AdminSession from './pages/AdminSession';

function App() {
  // N-125: сессия impersonation живёт в sessionStorage (см. AdminSession.js) — проверяем
  // её первой, иначе после редиректа на /dashboard (полная перезагрузка страницы) гард
  // не нашёл бы токен и вернул impersonation-вкладку на /login.
  const token = sessionStorage.getItem('clinicToken') || localStorage.getItem('clinicToken');
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin-session" element={<AdminSession />} />
        <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/referrals" element={token ? <Referrals /> : <Navigate to="/login" />} />
        <Route path="/transactions" element={token ? <Transactions /> : <Navigate to="/login" />} />
        <Route path="/commissions" element={token ? <Commissions /> : <Navigate to="/login" />} />
        <Route path="/operations" element={token ? <Operations /> : <Navigate to="/login" />} />
        <Route path="/stoplist" element={token ? <Stoplist /> : <Navigate to="/login" />} />
        <Route path="/services" element={token ? <Services /> : <Navigate to="/login" />} />
        <Route path="/support" element={token ? <Support /> : <Navigate to="/login" />} />
        <Route path="/profile" element={token ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/api" element={token ? <Api /> : <Navigate to="/login" />} />
        <Route path="/notifications" element={token ? <Notifications /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
